import {debug} from "../../utils";

export const ACTION_MLSETTINGS_CHANGED = "ACTION_MLSETTINGS_CHANGED";
export const ACTION_DOMAINMANAGEMENT_CHANGED = "ACTION_DOMAINMANAGEMENT_CHANGED";


export function SystemSettingsPageReducer(state = {}, action) {
    switch (action.type) {
        case ACTION_MLSETTINGS_CHANGED: {
            debug(`ReportsPageReducer ${ACTION_MLSETTINGS_CHANGED} is being processed...`)
            return {...state, ...action.payload};
        }
        case ACTION_DOMAINMANAGEMENT_CHANGED: {
            debug(`ReportsPageReducer ${ACTION_DOMAINMANAGEMENT_CHANGED} is being processed...`)
            return {...state, ...action.payload};
        }
        default:
            return state;
    }
}